<template>
  <div id="app">
    <rotate-device></rotate-device>
    <click-fullscreen></click-fullscreen>
    <modal></modal>
    <router-view></router-view>
  </div>
</template>

<!-- Main imports -->
<script>

import RotateDevice from 'components/Misc/RotateDevice'
import SwipeToMinimal from 'components/Misc/SwipeToMinimal'
import ClickFullscreen from 'components/Misc/ClickFullscreen'
import Modal from 'components/Modals/Modal'

export default {

  components: {
    RotateDevice,
    Modal,
    SwipeToMinimal,
    ClickFullscreen
  },

  computed: {

  },

  data: function(){
    return{
      fullscreenClick: true,
      platform: false,
    }
  },

	mounted(){

    var self = this;

    /*------------------------------------------*
      User leave promt
    --------------------------------------------*/
    window.onbeforeunload = function (e) {

      if(!window.localEnviroment && self.$store.state.updated){
        return "You have unsaved content, do you want to leave?"
      }

    }

    /*------------------------------------------*
      Animations
    --------------------------------------------*/

	  // Require animate csss
    require('vue2-animate/dist/vue2-animate.min.css')

    /*------------------------------------------*
      Fastclick
    --------------------------------------------*/

    // Activate fastclick js
    const FastClick = require('fastclick');
    FastClick.attach(document.body);

    /*------------------------------------------*
      Mobile screen handling
    --------------------------------------------*/

    // Detect if we have to handle IOS8+
    var platform = require('platform');
    self.platform = platform;

    var ua = navigator.userAgent || navigator.vendor || window.opera;
    var isFacebook = (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);

    if (platform.name == 'Safari' && platform.os.family == 'iOS' && parseInt(platform.os.version, 10) >= 8 && !isFacebook){
        setTimeout(function(){
            // Disable zoom
            document.addEventListener('touchmove', function (event) {
              if (event.scale !== 1) { event.preventDefault(); }
            }, { passive: false }); // Enforce the no-zoom policy on iOS devices.

            var lastTouchEnd = 0;
            document.addEventListener('touchend', function (event) {
              var now = (new Date()).getTime();
              if (now - lastTouchEnd <= 300) {
                event.preventDefault();
              }
              lastTouchEnd = now;
            }, false);

        }, 0);
    }
    else if(platform.name == 'Safari' && platform.os.family == 'iOS' && parseInt(platform.os.version, 10) <= 8){
      window.noAnimations = true;
      $("body").addClass("noAnimations")
    }

    /*------------------------------------------*
      Load cart and set session
    --------------------------------------------*/

    // Check url for cart ID
    const queryStrings = new URLSearchParams(window.location.search);
    const cartID = queryStrings.get('cart');
    const sessionID = this.$localStorage.get('sessionID');

    // 

    if(typeof cartID != 'undefined' && cartID){
      window.eventHub.$emit('loadBasket', cartID);

      // Use as session ID
      if(!sessionID)
         this.$localStorage.set('sessionID', cartID)

    }

    // If no cart ID is passed in url, try localStorage
    else if(this.$localStorage.get('basketID')){
      window.eventHub.$emit('loadBasket', this.$localStorage.get('basketID'));

      // Use as session ID
      if(!sessionID)
         this.$localStorage.set('sessionID', this.$localStorage.get('basketID'))

    }
    // We do not have a cart ID at all, create a brand new session
    else{
      this.$localStorage.set('sessionID', Math.floor(Math.random() * Date.now())) 
    }
    
	}
}
</script>

<!-- Main styles -->
<style>

html,body{
  height: 100%;
  font-size: 16px;
}

#app,.appContainer{
  height: 100%; width: 100%;
  overflow: hidden;
}

.page{
  height: 100%;
  transform: translate3d(0,0,0);
}

</style>



// WEBPACK FOOTER //
// App.vue?862f4f4e